export const MFE_STARTUP_AUTO_RELOAD_KEY = "mfe-startup-auto-reload-used";

export const claimMfeStartupAutoReload = (): boolean => {
  try {
    if (window.sessionStorage.getItem(MFE_STARTUP_AUTO_RELOAD_KEY) === "true") {
      return false;
    }

    window.sessionStorage.setItem(MFE_STARTUP_AUTO_RELOAD_KEY, "true");
    return true;
  } catch {
    return false;
  }
};
